var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSpayed = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  fill: "none",
  "aria-hidden": "true",
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M10.82 9.406 22.414 21c.18 1 .086 1.5-.796 2.032A8.96 8.96 0 0 1 17 24.945V27h2a1 1 0 1 1 0 2h-2v1a1 1 0 1 1-2 0v-1h-2a1 1 0 0 1 0-2h2v-2.055a9.001 9.001 0 0 1-6.032-14.562c.532-.883-.495-3.325 1.852-.977m-.426 2.402 9.798 9.799a7 7 0 0 1-9.798-9.798",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M22.595 18.355a7 7 0 0 0-8.949-8.949l-1.528-1.528a9 9 0 0 1 12.004 12.004z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M30.56 32 32 30.56l-8.837-8.838.003-.004-1.452-1.452-.003.004-9.981-9.98.004-.004-1.452-1.452-.004.003L1.44 0 0 1.44z",
  clipRule: "evenodd"
})));
export default SvgSpayed;